const zIndex = {
  loader: 2000,
  devtool: 3000,
};

export default zIndex;
